export const diningOptionsByPark = {
  "Magic Kingdom": [
{
      name: "Be Our Guest Restaurant",
      service: 'TS',
      category: "Character Dining – Meals with character meet-and-greets",
      cuisine: "American, French",
      price: "$$$$",
      location: "Magic Kingdom Park",
      tags: ["Immersive", "Reservations Required"],
      warningNote: "Prix-fixe dinner, very popular"
    },
{
      name: "Casey's Corner",
      service: 'QS',
      category: "Quick Service – Counter service, mobile order, fast-casual",
      cuisine: "American",
      price: "$",
      location: "Magic Kingdom Park",
      tags: ["Classic Park Food", "Hot Dogs"]
    },
{
      name: "Cinderella's Royal Table",
      service: 'TS',
      category: "Character Dining – Meals with character meet-and-greets",
      cuisine: "American",
      price: "$$$$",
      location: "Magic Kingdom Park",
      tags: ["Iconic Castle Experience"],
      warningNote: "Hard-to-get; book 60 days out"
    },
{
      name: "Columbia Harbour House",
      service: 'QS',
      category: "Quick Service – Counter service, mobile order, fast-casual",
      cuisine: "American",
      price: "$",
      location: "Magic Kingdom Park",
      tags: ["Seafood", "Hidden Gem"]
    },
{
      name: "Cosmic Ray's Starlight Café",
      service: 'QS',
      category: "Quick Service – Counter service, mobile order, fast-casual",
      cuisine: "American",
      price: "$",
      location: "Magic Kingdom Park",
      tags: ["Burgers", "Indoor Seating"]
    },
{
      name: "The Crystal Palace",
      service: 'TS',
      category: "Character Dining – Meals with character meet-and-greets",
      cuisine: "American, Buffet",
      price: "$$$$",
      location: "Magic Kingdom Park",
      tags: ["Buffet"],
      warningNote: "Winnie the Pooh character meal"
    },
{
      name: "The Diamond Horseshoe",
      service: 'TS',
      category: "Signature Dining – Upscale / \"Special Night\" Restaurants",
      cuisine: "American",
      price: "$$$",
      location: "Magic Kingdom Park",
      tags: ["Reservations Recommended"]
    },
{
      name: "The Friar's Nook",
      service: 'QS',
      category: "Quick Service – Counter service, mobile order, fast-casual",
      cuisine: "American",
      price: "$",
      location: "Magic Kingdom Park",
      tags: ["Mobile Order", "Kid-Friendly"]
    },
{
      name: "Jungle Navigation Co. LTD Skipper Canteen",
      service: 'TS',
      category: "Themed Dining – Immersive restaurants for atmosphere and fun",
      cuisine: "African, Asian, Latin",
      price: "$$",
      location: "Magic Kingdom Park",
      tags: ["Adventurous Palate", "Jungle Cruise Theme"]
    },
{
      name: "Liberty Tree Tavern",
      service: 'TS',
      category: "Signature Dining – Upscale / \"Special Night\" Restaurants",
      cuisine: "American",
      price: "$$$",
      location: "Magic Kingdom Park",
      tags: ["Hearty Meal", "Themed Colonial Experience"]
    },
{
      name: "Pecos Bill Tall Tale Inn and Cafe",
      service: 'QS',
      category: "Quick Service – Counter service, mobile order, fast-casual",
      cuisine: "Mexican",
      price: "$",
      location: "Magic Kingdom Park",
      tags: ["Tex-Mex", "Mobile Order"]
    },
{
      name: "Pinocchio Village Haus",
      service: 'QS',
      category: "Quick Service – Counter service, mobile order, fast-casual",
      cuisine: "American",
      price: "$",
      location: "Magic Kingdom Park",
      tags: ["Flatbreads", "Overlooks it's a small world"]
    },
{
      name: "The Plaza Restaurant",
      service: 'TS',
      category: "Themed Dining – Immersive restaurants for atmosphere and fun",
      cuisine: "American, Italian",
      price: "$$",
      location: "Magic Kingdom Park",
      tags: ["Classic Dining", "Main Street"]
    },
{
      name: "Sleepy Hollow",
      service: 'QS',
      category: "Quick Service – Counter service, mobile order, fast-casual",
      cuisine: "American",
      price: "$",
      location: "Magic Kingdom Park",
      tags: ["Breakfast Stop", "Funnel Cake"]
    },
{
      name: "Tony's Town Square Restaurant",
      service: 'TS',
      category: "Themed Dining – Immersive restaurants for atmosphere and fun",
      cuisine: "American, Italian",
      price: "$$",
      location: "Magic Kingdom Park",
      tags: ["Lady and the Tramp-themed", "Main Street Dining"]
    },
{
      name: "Tomorrowland Terrace Restaurant",
      service: 'QS',
      category: "Quick Service – Counter service, mobile order, fast-casual",
      cuisine: "American",
      price: "$",
      location: "Magic Kingdom Park",
      tags: ["Lobster Roll", "Outdoor Seating"]
    }
  ],
  "EPCOT": [
{
      name: "Akershus Royal Banquet Hall",
      service: 'TS',
      category: "Character Dining – Meals with character meet-and-greets",
      cuisine: "American, Norwegian",
      price: "$$$$",
      location: "EPCOT",
      warningNote: "Check Availability Calendar"
    },
{
      name: "Biergarten Restaurant",
      service: 'TS',
      category: "Signature Dining – Upscale / \"Special Night\" Restaurants",
      cuisine: "German",
      price: "$$$",
      location: "EPCOT",
      tags: ["Buffet", "Casual Dining"],
      warningNote: "Check Availability Calendar"
    },
{
      name: "Connections Eatery",
      service: 'QS',
      category: "Quick Service – Counter service, mobile order, fast-casual",
      cuisine: "American",
      price: "$",
      location: "EPCOT"
    },
{
      name: "Coral Reef Restaurant",
      service: 'TS',
      category: "Themed Dining – Immersive restaurants for atmosphere and fun",
      cuisine: "American, Seafood",
      price: "$$",
      location: "EPCOT",
      tags: ["A La Carte"],
      warningNote: "Check Availability Calendar"
    },
{
      name: "Garden Grill Restaurant",
      service: 'TS',
      category: "Character Dining – Meals with character meet-and-greets",
      cuisine: "American",
      price: "$$$$",
      location: "EPCOT",
      warningNote: "Check Availability Calendar"
    },
{
      name: "GEO-82",
      service: 'TS',
      category: "Themed Dining – Immersive restaurants for atmosphere and fun",
      cuisine: "American",
      price: "$$",
      location: "EPCOT",
      tags: ["A La Carte"],
      warningNote: "Check Availability Calendar"
    },
{
      name: "Katsura Grill",
      service: 'QS',
      category: "Quick Service – Counter service, mobile order, fast-casual",
      cuisine: "Asian, Japanese, Sushi",
      price: "$",
      location: "EPCOT"
    },
{
      name: "La Cantina de San Angel",
      service: 'QS',
      category: "Quick Service – Counter service, mobile order, fast-casual",
      cuisine: "Mexican",
      price: "$",
      location: "EPCOT"
    },
{
      name: "La Crêperie de Paris",
      service: 'TS',
      category: "Signature Dining – Upscale / \"Special Night\" Restaurants",
      cuisine: "French",
      price: "$$$",
      location: "EPCOT",
      tags: ["Casual Dining"],
      warningNote: "Check Availability Calendar"
    },
{
      name: "La Hacienda de San Angel",
      service: 'TS',
      category: "Themed Dining – Immersive restaurants for atmosphere and fun",
      cuisine: "Mexican",
      price: "$$",
      location: "EPCOT",
      tags: ["A La Carte", "Casual Dining"],
      warningNote: "Check Availability Calendar"
    },
{
      name: "Le Cellier Steakhouse",
      service: 'TS',
      category: "Signature Dining – Upscale / \"Special Night\" Restaurants",
      cuisine: "American, Steakhouse",
      price: "$$$",
      location: "EPCOT",
      tags: ["A La Carte"],
      warningNote: "Check Availability Calendar"
    },
{
      name: "Lotus Blossom Café",
      service: 'QS',
      category: "Quick Service – Counter service, mobile order, fast-casual",
      cuisine: "Asian, Chinese",
      price: "$",
      location: "EPCOT"
    },
{
      name: "Monsieur Paul",
      service: 'TS',
      category: "Signature Dining – Upscale / \"Special Night\" Restaurants",
      cuisine: "French",
      price: "$$$$",
      location: "EPCOT",
      warningNote: "Check Availability Calendar"
    },
{
      name: "Nine Dragons Restaurant",
      service: 'TS',
      category: "Themed Dining – Immersive restaurants for atmosphere and fun",
      cuisine: "Asian, Chinese",
      price: "$$",
      location: "EPCOT",
      tags: ["A La Carte"],
      warningNote: "Check Availability Calendar"
    },
{
      name: "Regal Eagle Smokehouse: Craft Drafts & Barbecue",
      service: 'QS',
      category: "Quick Service – Counter service, mobile order, fast-casual",
      cuisine: "American",
      price: "$",
      location: "EPCOT"
    },
{
      name: "Restaurant Marrakesh - Temporarily Unavailable",
      service: 'TS',
      category: "Themed Dining – Immersive restaurants for atmosphere and fun",
      cuisine: "Mediterranean, Moroccan",
      price: "$$",
      location: "EPCOT",
      tags: ["A La Carte"]
    },
{
      name: "Rose & Crown Dining Room",
      service: 'TS',
      category: "Themed Dining – Immersive restaurants for atmosphere and fun",
      cuisine: "British",
      price: "$$",
      location: "EPCOT",
      tags: ["A La Carte"],
      warningNote: "Check Availability Calendar"
    },
{
      name: "San Angel Inn Restaurante",
      service: 'TS',
      category: "Themed Dining – Immersive restaurants for atmosphere and fun",
      cuisine: "Mexican",
      price: "$$",
      location: "EPCOT",
      tags: ["A La Carte", "Casual Dining"],
      warningNote: "Check Availability Calendar"
    },
{
      name: "Shiki-Sai: Sushi Izakaya",
      service: 'TS',
      category: "Themed Dining – Immersive restaurants for atmosphere and fun",
      cuisine: "Asian, Japanese, Sushi",
      price: "$$",
      location: "EPCOT",
      tags: ["A La Carte"],
      warningNote: "Check Availability Calendar"
    },
{
      name: "Sommerfest",
      service: 'QS',
      category: "Quick Service – Counter service, mobile order, fast-casual",
      cuisine: "German",
      price: "$",
      location: "EPCOT",
      tags: ["Mobile Orders"]
    },
{
      name: "Space 220 Restaurant",
      service: 'TS',
      category: "Themed Dining – Immersive restaurants for atmosphere and fun",
      cuisine: "American",
      price: "$$$",
      location: "EPCOT",
      tags: ["Casual Dining", "Prix Fixe"],
      warningNote: "Check Availability Calendar"
    },
{
      name: "Spice Road Table",
      service: 'TS',
      category: "Themed Dining – Immersive restaurants for atmosphere and fun",
      cuisine: "Mediterranean",
      price: "$",
      location: "EPCOT",
      tags: ["A La Carte", "Casual Dining"],
      warningNote: "Check Availability Calendar"
    },
{
      name: "Sunshine Seasons",
      service: 'QS',
      category: "Quick Service – Counter service, mobile order, fast-casual",
      cuisine: "American",
      price: "$",
      location: "EPCOT"
    },
{
      name: "Takumi-Tei",
      service: 'TS',
      category: "Signature Dining – Upscale / \"Special Night\" Restaurants",
      cuisine: "Asian, Japanese, Seafood",
      price: "$$$$",
      location: "EPCOT",
      warningNote: "Check Availability Calendar"
    },
{
      name: "Teppan Edo",
      service: 'TS',
      category: "Themed Dining – Immersive restaurants for atmosphere and fun",
      cuisine: "Asian, Japanese, Sushi",
      price: "$$",
      location: "EPCOT",
      tags: ["A La Carte"],
      warningNote: "Check Availability Calendar"
    },
{
      name: "Tutto Italia Ristorante",
      service: 'TS',
      category: "Themed Dining – Immersive restaurants for atmosphere and fun",
      cuisine: "Italian",
      price: "$$",
      location: "EPCOT",
      tags: ["A La Carte", "Casual Dining"],
      warningNote: "Check Availability Calendar"
    },
{
      name: "Via Napoli Ristorante e Pizzeria",
      service: 'TS',
      category: "Themed Dining – Immersive restaurants for atmosphere and fun",
      cuisine: "Italian",
      price: "$$",
      location: "EPCOT",
      tags: ["A La Carte", "Casual Dining"],
      warningNote: "Check Availability Calendar"
    },
{
      name: "Yorkshire County Fish Shop",
      service: 'QS',
      category: "Quick Service – Counter service, mobile order, fast-casual",
      cuisine: "American, British",
      price: "$",
      location: "EPCOT"
    }
  ],
  "Disney's BoardWalk": [
{
      name: "Flying Fish",
      service: 'TS',
      category: "Signature Dining – Upscale / \"Special Night\" Restaurants",
      cuisine: "American, Seafood",
      price: "$$$",
      location: "Disney's BoardWalk",
      tags: ["A La Carte"],
      warningNote: "Check Availability Calendar"
    },
{
      name: "Roses of Gold Afternoon Tea at The Cake Bake Shop® by Gwendolyn Rogers",
      service: 'TS',
      category: "Signature Dining – Upscale / \"Special Night\" Restaurants",
      cuisine: "American",
      price: "$$$$",
      location: "Disney's BoardWalk",
      tags: ["Dining Events"]
    },
{
      name: "Trattoria al Forno",
      service: 'TS',
      category: "Themed Dining – Immersive restaurants for atmosphere and fun",
      cuisine: "Italian",
      price: "$$",
      location: "Disney's BoardWalk",
      tags: ["A La Carte", "Casual Dining"],
      warningNote: "Check Availability Calendar"
    }
  ],
  "Disney Springs": [
{
      name: "Jaleo by José Andrés",
      service: 'TS',
      category: "Signature Dining – Upscale / \"Special Night\" Restaurants",
      cuisine: "Seafood, Spanish",
      price: "$$",
      location: "Disney Springs",
      warningNote: "Check Availability Calendar"
    },
{
      name: "4 Rivers Cantina Barbacoa Food Truck",
      service: 'QS',
      category: "Quick Service – Counter service, mobile order, fast-casual",
      cuisine: "Latin, Mexican",
      price: "$",
      location: "Disney Springs",
      tags: ["Food Truck"]
    },
{
      name: "B.B. Wolf's Sausage Co.",
      service: 'QS',
      category: "Quick Service – Counter service, mobile order, fast-casual",
      cuisine: "American",
      price: "$",
      location: "Disney Springs",
      tags: ["Mobile Orders"]
    },
{
      name: "Blaze Fast-Fire'd Pizza",
      service: 'QS',
      category: "Quick Service – Counter service, mobile order, fast-casual",
      cuisine: "American",
      price: "$",
      location: "Disney Springs",
      tags: ["Pizza"]
    },
{
      name: "The BOATHOUSE®: Great Food, Waterfront Dining, Dream Boats™",
      service: 'TS',
      category: "Signature Dining – Upscale / \"Special Night\" Restaurants",
      cuisine: "American, Seafood, Steakhouse",
      price: "$$$",
      location: "Disney Springs",
      tags: ["A La Carte"],
      warningNote: "Check Availability Calendar"
    },
{
      name: "Chef Art Smith's Homecomin'",
      service: 'TS',
      category: "Themed Dining – Immersive restaurants for atmosphere and fun",
      cuisine: "American",
      price: "$$",
      location: "Disney Springs",
      tags: ["A La Carte"],
      warningNote: "Check Availability Calendar"
    },
{
      name: "Chicken Guy!",
      service: 'QS',
      category: "Quick Service – Counter service, mobile order, fast-casual",
      cuisine: "American",
      price: "$",
      location: "Disney Springs"
    },
{
      name: "City Works Eatery & Pour House",
      service: 'TS',
      category: "Themed Dining – Immersive restaurants for atmosphere and fun",
      cuisine: "American",
      price: "$$",
      location: "Disney Springs",
      tags: ["A La Carte"],
      warningNote: "Check Availability Calendar"
    },
{
      name: "Cookes of Dublin",
      service: 'QS',
      category: "Quick Service – Counter service, mobile order, fast-casual",
      cuisine: "American, Irish",
      price: "$",
      location: "Disney Springs"
    },
{
      name: "D-Luxe Burger",
      service: 'QS',
      category: "Quick Service – Counter service, mobile order, fast-casual",
      cuisine: "American",
      price: "$",
      location: "Disney Springs"
    },
{
      name: "The Edison",
      service: 'TS',
      category: "Themed Dining – Immersive restaurants for atmosphere and fun",
      cuisine: "American",
      price: "$$",
      location: "Disney Springs",
      tags: ["A La Carte"],
      warningNote: "Check Availability Calendar"
    },
{
      name: "eet by Maneet Chauhan",
      service: 'QS',
      category: "Quick Service – Counter service, mobile order, fast-casual",
      cuisine: "Indian",
      price: "$$",
      location: "Disney Springs"
    },
{
      name: "Enzo's Hideaway",
      service: 'TS',
      category: "Themed Dining – Immersive restaurants for atmosphere and fun",
      cuisine: "Italian",
      price: "$$",
      location: "Disney Springs",
      tags: ["A La Carte", "Casual Dining"],
      warningNote: "Check Availability Calendar"
    },
{
      name: "Frontera Cocina",
      service: 'TS',
      category: "Themed Dining – Immersive restaurants for atmosphere and fun",
      cuisine: "Mexican",
      price: "$$",
      location: "Disney Springs",
      tags: ["A La Carte", "Casual Dining"],
      warningNote: "Check Availability Calendar"
    },
{
      name: "House of Blues Restaurant & Bar",
      service: 'TS',
      category: "Themed Dining – Immersive restaurants for atmosphere and fun",
      cuisine: "American",
      price: "$$",
      location: "Disney Springs",
      tags: ["A La Carte"],
      warningNote: "Check Availability Calendar"
    },
{
      name: "Maria & Enzo's Ristorante",
      service: 'TS',
      category: "Themed Dining – Immersive restaurants for atmosphere and fun",
      cuisine: "Italian",
      price: "$$",
      location: "Disney Springs",
      tags: ["A La Carte", "Casual Dining"],
      warningNote: "Check Availability Calendar"
    },
{
      name: "Morimoto Asia",
      service: 'TS',
      category: "Signature Dining – Upscale / \"Special Night\" Restaurants",
      cuisine: "Asian, Chinese, Japanese",
      price: "$$$",
      location: "Disney Springs",
      warningNote: "Check Availability Calendar"
    },
{
      name: "Paddlefish",
      service: 'TS',
      category: "Signature Dining – Upscale / \"Special Night\" Restaurants",
      cuisine: "American, Seafood",
      price: "$$$",
      location: "Disney Springs",
      tags: ["A La Carte"],
      warningNote: "Check Availability Calendar"
    },
{
      name: "Paradiso 37, Taste of the Americas",
      service: 'TS',
      category: "Themed Dining – Immersive restaurants for atmosphere and fun",
      cuisine: "American, Latin, Steakhouse",
      price: "$$",
      location: "Disney Springs",
      tags: ["A La Carte"],
      warningNote: "Check Availability Calendar"
    },
{
      name: "Pepe by José Andrés",
      service: 'TS',
      category: "Themed Dining – Immersive restaurants for atmosphere and fun",
      cuisine: "Spanish",
      price: "$",
      location: "Disney Springs"
    },
{
      name: "Pizza Ponte",
      service: 'QS',
      category: "Quick Service – Counter service, mobile order, fast-casual",
      cuisine: "Italian",
      price: "$",
      location: "Disney Springs"
    },
{
      name: "Planet Hollywood",
      service: 'TS',
      category: "Themed Dining – Immersive restaurants for atmosphere and fun",
      cuisine: "American",
      price: "$$",
      location: "Disney Springs",
      tags: ["A La Carte"],
      warningNote: "Check Availability Calendar"
    },
{
      name: "The Polite Pig",
      service: 'QS',
      category: "Quick Service – Counter service, mobile order, fast-casual",
      cuisine: "American",
      price: "$",
      location: "Disney Springs"
    },
{
      name: "Raglan Road™ Irish Pub and Restaurant",
      service: 'TS',
      category: "Themed Dining – Immersive restaurants for atmosphere and fun",
      cuisine: "Irish",
      price: "$$",
      location: "Disney Springs",
      tags: ["A La Carte", "Casual Dining"],
      warningNote: "Check Availability Calendar"
    },
{
      name: "Rainforest Cafe® at Disney Springs Marketplace",
      service: 'TS',
      category: "Themed Dining – Immersive restaurants for atmosphere and fun",
      cuisine: "American",
      price: "$$",
      location: "Disney Springs",
      tags: ["A La Carte"],
      warningNote: "Check Availability Calendar"
    },
{
      name: "Splitsville Dining Room",
      service: 'TS',
      category: "Themed Dining – Immersive restaurants for atmosphere and fun",
      cuisine: "American",
      price: "$$",
      location: "Disney Springs",
      tags: ["A La Carte"],
      warningNote: "Check Availability Calendar"
    },
{
      name: "STK® Steakhouse",
      service: 'TS',
      category: "Signature Dining – Upscale / \"Special Night\" Restaurants",
      cuisine: "American, Seafood, Steakhouse",
      price: "$$$",
      location: "Disney Springs",
      tags: ["A La Carte"],
      warningNote: "Check Availability Calendar"
    },
{
      name: "T-REX ™",
      service: 'TS',
      category: "Themed Dining – Immersive restaurants for atmosphere and fun",
      cuisine: "American",
      price: "$$",
      location: "Disney Springs",
      tags: ["A La Carte"],
      warningNote: "Check Availability Calendar"
    },
{
      name: "Terralina Crafted Italian",
      service: 'TS',
      category: "Themed Dining – Immersive restaurants for atmosphere and fun",
      cuisine: "Italian",
      price: "$$",
      location: "Disney Springs",
      tags: ["A La Carte", "Casual Dining"],
      warningNote: "Check Availability Calendar"
    },
{
      name: "The Turf Club Bar and Grill",
      service: 'TS',
      category: "Themed Dining – Immersive restaurants for atmosphere and fun",
      cuisine: "American",
      price: "$$",
      location: "Disney's Saratoga Springs Resort & Spa",
      tags: ["A La Carte"],
      warningNote: "Check Availability Calendar"
    },
{
      name: "Wine Bar George – A Restaurant & Bar",
      service: 'TS',
      category: "Themed Dining – Immersive restaurants for atmosphere and fun",
      cuisine: "American",
      price: "$$",
      location: "Disney Springs",
      tags: ["A La Carte"],
      warningNote: "Check Availability Calendar"
    },
{
      name: "Wolfgang Puck Bar & Grill",
      service: 'TS',
      category: "Themed Dining – Immersive restaurants for atmosphere and fun",
      cuisine: "American",
      price: "$$",
      location: "Disney Springs",
      tags: ["A La Carte", "Casual Dining"],
      warningNote: "Check Availability Calendar"
    }
  ],
  "Animal Kingdom": [
{
      name: "Tiffins Restaurant",
      service: 'TS',
      category: "Signature Dining – Upscale / \"Special Night\" Restaurants",
      cuisine: "African, Asian, Latin",
      price: "$$$",
      location: "Disney's Animal Kingdom Theme Park",
      warningNote: "Check Availability Calendar"
    },
{
      name: "Flame Tree Barbecue",
      service: 'QS',
      category: "Quick Service – Counter service, mobile order, fast-casual",
      cuisine: "American",
      price: "$",
      location: "Disney's Animal Kingdom Theme Park"
    },
{
      name: "Harambe Market",
      service: 'QS',
      category: "Quick Service – Counter service, mobile order, fast-casual",
      cuisine: "African",
      price: "$",
      location: "Disney's Animal Kingdom Theme Park"
    },
{
      name: "Pizzafari",
      service: 'QS',
      category: "Quick Service – Counter service, mobile order, fast-casual",
      cuisine: "American",
      price: "$",
      location: "Disney's Animal Kingdom Theme Park"
    },
{
      name: "Rainforest Cafe® at Disney's Animal Kingdom",
      service: 'TS',
      category: "Themed Dining – Immersive restaurants for atmosphere and fun",
      cuisine: "American",
      price: "$$",
      location: "Disney's Animal Kingdom Theme Park",
      tags: ["A La Carte"],
      warningNote: "Check Availability Calendar"
    },
{
      name: "Restaurantosaurus",
      service: 'QS',
      category: "Quick Service – Counter service, mobile order, fast-casual",
      cuisine: "American",
      price: "$",
      location: "Disney's Animal Kingdom Theme Park"
    },
{
      name: "Satu'li Canteen",
      service: 'QS',
      category: "Quick Service – Counter service, mobile order, fast-casual",
      cuisine: "American",
      price: "$",
      location: "Disney's Animal Kingdom Theme Park"
    },
{
      name: "Tusker House Restaurant",
      service: 'TS',
      category: "Character Dining – Meals with character meet-and-greets",
      cuisine: "African, American",
      price: "$$$$",
      location: "Disney's Animal Kingdom Theme Park",
      tags: ["Buffet"],
      warningNote: "Check Availability Calendar"
    },
{
      name: "Yak & Yeti™ Local Food Cafes",
      service: 'QS',
      category: "Quick Service – Counter service, mobile order, fast-casual",
      cuisine: "American, Asian",
      price: "$",
      location: "Disney's Animal Kingdom Theme Park"
    },
{
      name: "Yak & Yeti™ Restaurant",
      service: 'TS',
      category: "Themed Dining – Immersive restaurants for atmosphere and fun",
      cuisine: "American, Asian, Chinese",
      price: "$$",
      location: "Disney's Animal Kingdom Theme Park",
      tags: ["A La Carte"],
      warningNote: "Check Availability Calendar"
    }
  ],
  "Hollywood Studios": [
{
      name: "50's Prime Time Café",
      service: 'TS',
      category: "Themed Dining – Immersive restaurants for atmosphere and fun",
      cuisine: "American",
      price: "$$",
      location: "Disney's Hollywood Studios",
      tags: ["A La Carte"],
      warningNote: "Check Availability Calendar"
    },
{
      name: "ABC Commissary",
      service: 'QS',
      category: "Quick Service – Counter service, mobile order, fast-casual",
      cuisine: "American",
      price: "$",
      location: "Disney's Hollywood Studios"
    },
{
      name: "Backlot Express",
      service: 'QS',
      category: "Quick Service – Counter service, mobile order, fast-casual",
      cuisine: "American",
      price: "$",
      location: "Disney's Hollywood Studios"
    },
{
      name: "Catalina Eddie's",
      service: 'QS',
      category: "Quick Service – Counter service, mobile order, fast-casual",
      cuisine: "American",
      price: "$",
      location: "Disney's Hollywood Studios",
      tags: ["Mobile Orders"]
    },
{
      name: "Docking Bay 7 Food and Cargo",
      service: 'QS',
      category: "Quick Service – Counter service, mobile order, fast-casual",
      cuisine: "American",
      price: "$$",
      location: "Disney's Hollywood Studios"
    },
{
      name: "Dockside Diner",
      service: 'QS',
      category: "Quick Service – Counter service, mobile order, fast-casual",
      cuisine: "American",
      price: "$",
      location: "Disney's Hollywood Studios",
      tags: ["Mobile Orders"]
    },
{
      name: "Fairfax Fare",
      service: 'QS',
      category: "Quick Service – Counter service, mobile order, fast-casual",
      cuisine: "American",
      price: "$",
      location: "Disney's Hollywood Studios",
      tags: ["Mobile Orders"]
    },
{
      name: "The Hollywood Brown Derby",
      service: 'TS',
      category: "Signature Dining – Upscale / \"Special Night\" Restaurants",
      cuisine: "American",
      price: "$$$",
      location: "Disney's Hollywood Studios",
      tags: ["A La Carte"],
      warningNote: "Check Availability Calendar"
    },
{
      name: "Hollywood & Vine",
      service: 'TS',
      category: "Signature Dining – Upscale / \"Special Night\" Restaurants",
      cuisine: "American",
      price: "$$$$",
      location: "Disney's Hollywood Studios",
      tags: ["Buffet"],
      warningNote: "Check Availability Calendar"
    },
{
      name: "Jazzy Holidays at The Hollywood Brown Derby",
      service: 'TS',
      category: "Themed Dining – Immersive restaurants for atmosphere and fun",
      cuisine: "American",
      price: "$$",
      location: "Disney's Hollywood Studios",
      tags: ["A La Carte"]
    },
{
      name: "Kat Saka's Kettle",
      service: 'QS',
      category: "Quick Service – Counter service, mobile order, fast-casual",
      cuisine: "American",
      price: "$",
      location: "Disney's Hollywood Studios",
      tags: ["Mobile Orders"]
    },
{
      name: "Milk Stand",
      service: 'QS',
      category: "Quick Service – Counter service, mobile order, fast-casual",
      cuisine: "American",
      price: "$",
      location: "Disney's Hollywood Studios",
      tags: ["Mobile Orders"]
    },
{
      name: "Ronto Roasters",
      service: 'QS',
      category: "Quick Service – Counter service, mobile order, fast-casual",
      cuisine: "American",
      price: "$",
      location: "Disney's Hollywood Studios",
      tags: ["Mobile Orders"]
    },
{
      name: "Rosie's All-American Café",
      service: 'QS',
      category: "Quick Service – Counter service, mobile order, fast-casual",
      cuisine: "American",
      price: "$",
      location: "Disney's Hollywood Studios",
      tags: ["Mobile Orders"]
    },
{
      name: "Roundup Rodeo BBQ",
      service: 'TS',
      category: "Signature Dining – Upscale / \"Special Night\" Restaurants",
      cuisine: "American",
      price: "$$$",
      location: "Disney's Hollywood Studios",
      tags: ["Casual Dining"],
      warningNote: "Check Availability Calendar"
    },
{
      name: "Sci-Fi Dine-In Theater Restaurant",
      service: 'TS',
      category: "Themed Dining – Immersive restaurants for atmosphere and fun",
      cuisine: "American",
      price: "$$",
      location: "Disney's Hollywood Studios",
      tags: ["A La Carte"],
      warningNote: "Check Availability Calendar"
    },
{
      name: "Woody's Lunch Box",
      service: 'QS',
      category: "Quick Service – Counter service, mobile order, fast-casual",
      cuisine: "American",
      price: "$",
      location: "Disney's Hollywood Studios",
      tags: ["Mobile Orders"]
    }
  ],
  "Disney's Blizzard Beach Water Park": [
{
      name: "Avalunch",
      service: 'QS',
      category: "Quick Service – Counter service, mobile order, fast-casual",
      cuisine: "American",
      price: "$",
      location: "Disney's Blizzard Beach Water Park",
      tags: ["Mobile Orders"]
    },
{
      name: "Lottawatta Lodge",
      service: 'QS',
      category: "Quick Service – Counter service, mobile order, fast-casual",
      cuisine: "American",
      price: "$",
      location: "Disney's Blizzard Beach Water Park"
    },
{
      name: "Warming Hut",
      service: 'QS',
      category: "Quick Service – Counter service, mobile order, fast-casual",
      cuisine: "American",
      price: "$",
      location: "Disney's Blizzard Beach Water Park",
      tags: ["Mobile Orders"]
    }
  ],
  "Disney's Typhoon Lagoon Water Park": [
{
      name: "Leaning Palms",
      service: 'QS',
      category: "Quick Service – Counter service, mobile order, fast-casual",
      cuisine: "American",
      price: "$",
      location: "Disney's Typhoon Lagoon Water Park"
    },
{
      name: "Typhoon Tilly's",
      service: 'QS',
      category: "Quick Service – Counter service, mobile order, fast-casual",
      cuisine: "American",
      price: "$",
      location: "Disney's Typhoon Lagoon Water Park",
      tags: ["Mobile Orders"]
    }
  ],
};
